import { render, staticRenderFns } from "./promotionEditor.vue?vue&type=template&id=2b38a45f"
import script from "./promotionEditor.vue?vue&type=script&lang=js"
export * from "./promotionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports